export enum PersistedStorageKeys {
    TagSelected = "agentsTableTags",
    TagGroupSelected = "agentsTableTagGroups",
    LiveSummaryTagGroupSelected = "liveSummaryTagGroup",
    InteractionDetailsIsOpen = "InteractionDetailsIsOpen",
    InteractionMetricsIsOpen = "InteractionMetricsIsOpen",
    AiInteractionSummaryIsOpen = "AiInteractionSummaryIsOpen",
    PhraseTags = "PhraseTags",
    ExternalTags = "ExternalTags",
    AutomaticTags = "AutomaticTags",
    ComparisonTableOptions = "comparisonTableOptions",
    ComparisonViewOptions = "comparisonViewCustomOptions",
    ComparisonViewCustomMetrics = "comparisonViewCustomMetrics",
    SelectedPresetId = "selectedPresetId",
}
